import Axios from 'axios';
import qs from 'qs';
import { RETURNS_PARTNO_LIST, NO_RETURNS_NEEDED_CB, RETURNS, ROTATE_REQUEST_PARTNO_LIST, NO_ROTATES_NEEDED_CB, ROTATES_OUT_OF_STOCK, UPDATE_INVENTORY_DETAIL_BIN, CORE_PICKUP, ROTATES, ROTATE_REQUEST, PRINT_CONFIRMATION_CLEAR_MESSAGES, PRINT_CONFIRMATION_RESPONSE, ROWS_DATA_SELECTED_INDEX_STATE, FETCH_ORDERNOS_PRINT, FETCH_INVOICES_PRINT_RECORD_PRINTED, FETCH_RESET_INVOICES_PRINT, FETCH_INVOICES_PRINT, FETCH_INVOICES, PRINT_ORDER, PRINT_TRANSFER, STATUS_ERR_MESSAGE, STATUS_NOTICE_MESSAGE, STATUS_UPDATE_STATE_RESET, SUBMIT_CUST_CORE_RESPONSE, VALIDATE_PARTNO, DELETE_ROW_LINE_ORDERNO_DETAIL, ADD_LINE_ORDERNO_DETAIL, SUBMIT_ORDER_RESPONSE, SUBMIT_TRANSFER_RESPONSE, FETCH_INVENTORY_RESET, FETCH_INVENTORY_DETAIL, FETCH_INVENTORY, CUSTOMER_TRANSFER_STATE_RESET, FETCH_CUSTNO_DETAIL, FETCH_CUSTOMERS, ORDER_TRANSFER_STATE_RESET, FETCH_ORDERNO_DETAIL, FETCH_ORDERS, TRANSFERNO_STATE_RESET, HAS_ERRORS, FETCH_POSTS, NEW_POSTS, FETCH_LOADTRUCKS, FETCH_LOC, FETCH_TRANSFERS, FETCH_TRANSFERNO_DETAIL } from './actionTypes';
import { BASEURL2, HEADERS, HEADERS_JSON } from './index';
import moment from "moment";

//TESTING PURPOSES
export const fetchPosts = () => dispatch => {
    // console.log("PostActions fetchPosts");

    fetch('https://jsonplaceholder.typicode.com/posts')
    .then(res => res.json())
    .then(posts =>
        dispatch({
            type: FETCH_POSTS,
            payload: posts
        })
    );
};

//TESTING PURPOSES
export const createPost = (postData) => dispatch => {
    // console.log("PostActions createPost");

    fetch('https://jsonplaceholder.typicode.com/posts/1', {
        // method: 'POSTS',
        method: 'PUT',
        headers: {
            'content-type': 'application/json; charset=UTF-8',
        },  
        // body: JSON.stringify({
        //     id: 1,
        //     title: 'foo',
        //     body: 'bar',
        //     userId: 1,
        //   })      
         body: JSON.stringify(postData)
    })
    .then(res => res.json())
    .then(post => dispatch({
        type: NEW_POSTS,
        payload: post
        })
    )
    .then(json => console.log('PostActions json: ' + JSON.stringify(json)))
    .catch(error => console.log('PostActions Authorization failed : ' + error.message));
};

//TESTING PURPOSES
export const fetchLoadTrucks = () => dispatch => {
    // console.log("fetchLoadTrucks");
    
    // //fetch('http://192.168.211.231/BTAPI/?action=loadTrucks', {
    // fetch('/', {

    // method: 'GET',
    //     headers: {'Content-Type': 'application/json; charset=UTF-8',
    //     'Access-Control-Allow-Origin': '*',
    //     }

    // })
    // .then(res => res.json())
    // .then(json => console.log('PostActions json: ' + JSON.stringify(json)))
    // // .then(postsTrucks =>
    // //     dispatch({
    // //         type: FETCH_LOADTRUCKS,
    // //         payload: postsTrucks
    // //     })
    // // );
};

//TESTING PURPOSES
export const fetchLoc = () => dispatch => {
    // console.log('PostActions fetchLoc called');
    try{
        Axios.post('http://localhost:8081/loc').then( function(response){
            //console.log('PostActions fetchLoc response: ' + JSON.stringify(response.data.message))
            if( typeof(response.data.message) !== 'undefined' ){
                dispatch({                   
                    type: FETCH_LOC,   
                    payload: response.data.message
                })
                // console.log('PostActions fetchLoc retrieved')
                // console.log('fetchLoc response.data.message: ' + JSON.stringify(response.data.message) )
            }else{
                console.log('PostActions fetchLoc unable to retrieve')
            }            
        });


    } catch (err){
        console.log('PostActions fetchLoc failed : ' + err)
    }  
};

// const headers = {
//     'Content-Type': 'application/x-www-form-urlencoded',
//     // 'Access-Control-Allow-Origin': '*'
// }

function hideLandingPageClasses(){
    var landingPageCollection = document.getElementsByClassName('landingPageTblClass');
    for (let i = 0; i < landingPageCollection.length; i++) { 
        landingPageCollection[i].classList.add("hideClass");      
    } 

    var detailTblCollection = document.getElementsByClassName('detailTblClass');
    for (let i = 0; i < detailTblCollection.length; i++) { 
        detailTblCollection[i].classList.remove("hideClass");      
    }     
}

function unhideLandingPageClasses(){
    var landingPageCollection = document.getElementsByClassName('landingPageTblClass');
    for (let i = 0; i < landingPageCollection.length; i++) { 
        landingPageCollection[i].classList.remove("hideClass");      
    }    
    
    var detailTblCollection = document.getElementsByClassName('detailTblClass');
    for (let i = 0; i < detailTblCollection.length; i++) { 
        detailTblCollection[i].classList.remove("hideClass");      
    }     
}

export const fetchTransfers = (user) => dispatch => {    
    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name}

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchTransfers`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            //console.log('PostActions fetchTransfers data: ' + JSON.stringify(data)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' ){

                const formattedData = data.message.map(row => {
                    const updatedRow = {
                        ...row,
                        ORDERED: row.ORDERED !== null && row.ORDERED !== '' ? moment(row.ORDERED, 'MM/DD/YYYY').toDate() : '',
                        SHIPPED: row.SHIPPED !== null && row.SHIPPED !== '' ? moment(row.SHIPPED, 'MM/DD/YYYY').toDate() : '',
                    }
                    return updatedRow;
                });

                dispatch({
                    type: FETCH_TRANSFERS,
                    payload: formattedData,
                });                
                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchTransfers data notify:' + JSON.stringify(data['NOTIFY'])); 
                dispatch({
                    type: FETCH_TRANSFERS,
                    payload: data['NOTIFY'],
                });                
                                
            }
            else{

                var failedResponse = 'Fetch Transfers Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 

                // dispatch({
                //     type: AuthActionType.LOGIN_FAIL,
                //     payload: failedResponse
                // });

                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchTransfers fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchTransfers error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchTransfernoDetail = (user, transferno, toloc, fromloc) => dispatch => {    
    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name, 'TRANSFERNO': transferno, 'TOLOC': toloc, 'FROMLOC': fromloc}

        dispatch({
            type: STATUS_UPDATE_STATE_RESET
        });  

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchTransfernoDetail`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            //console.log('PostActions fetchTransfernoDetail data: ' + JSON.stringify(data)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                dispatch({
                    type: ORDER_TRANSFER_STATE_RESET
                });     
                dispatch({
                    type: CUSTOMER_TRANSFER_STATE_RESET
                });      
                dispatch({
                    type: FETCH_INVENTORY_RESET
                });                                              
                dispatch({
                    type: FETCH_TRANSFERNO_DETAIL,
                    payload: data.message,
                });                
                
                hideLandingPageClasses()   
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchTransfernoDetail data notify:' + JSON.stringify(data['NOTIFY'])); 
                
                //dispatch(fetchTransfers(user));

                dispatch({
                    type: STATUS_NOTICE_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }               
            else{

                var failedResponse = 'Fetch Transfers Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 

                // dispatch({
                //     type: AuthActionType.LOGIN_FAIL,
                //     payload: failedResponse
                // });

                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchTransfernoDetail fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchTransfernoDetail error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
}; 


export const fetchSubmitTransfernoDetail = (user, headerState, detailState) => {
    return async (dispatch) => {
        try{

            let submitTransfernoDetailState = {}
            let indexKey = 0
            let states = Object.assign({}, user, headerState, detailState);
            // console.log('fetchSubmitTransfernoDetail user: ' + JSON.stringify(user));
            // console.log('fetchSubmitTransfernoDetail headerState: ' + JSON.stringify(headerState));

            detailState.flatMap(element => {
                submitTransfernoDetailState[indexKey] = [element['LINENO'], element['PRDID'], element['LINE'], element['PARTNO'], element['ORDERQTY'], element['TRANSFERQTY'], element['USER_INPUT_QTY']]
                indexKey=indexKey+1;
            })            
            submitTransfernoDetailState['userid'] = user['userid']
            submitTransfernoDetailState['TRANSFERNO'] = headerState['TRANSFERNO']
            submitTransfernoDetailState['FROMLOC'] = headerState['FROMLOC']
            submitTransfernoDetailState['TOLOC'] = headerState['TOLOC']
            submitTransfernoDetailState['MODE'] = headerState['MODE']
           

            // console.log('fetchSubmitTransfernoDetail submitTransfernoDetailState: ' + JSON.stringify(submitTransfernoDetailState));

            const res = await Axios.post(`${BASEURL2}/submitTransfernoDetail`, qs.stringify(submitTransfernoDetailState, { indices: false }), { HEADERS });
            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined'&& typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){ 
                // console.log('PostActions fetchSubmitTransfernoDetail data message: ' + JSON.stringify(data['message']));

                dispatch({
                    type: SUBMIT_TRANSFER_RESPONSE,
                    payload: data['message']
                })
                unhideLandingPageClasses()        
            }
            else{    
                console.log('PostActions fetchSubmitTransfernoDetail data[ERROR]: ' + JSON.stringify(data['ERROR']));     

                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: data['ERROR']
                }) 
            }                      
        } catch (error){
            console.log('PostActions fetchSubmitTransfernoDetail failed error: ' + error)
            dispatch({                    
                type: STATUS_ERR_MESSAGE,   
                payload: error
            })            
        }  
    }
};

export const fetchSubmitPartialTransfernoDetail = (user, headerState, detailState) => {
    return async (dispatch) => {
        try{

            let submitTransfernoDetailState = {}
            let indexKey = 0
            let states = Object.assign({}, user, headerState, detailState);
            // console.log('fetchSubmitPartialTransfernoDetail user: ' + JSON.stringify(user));
            // console.log('fetchSubmitPartialTransfernoDetail headerState: ' + JSON.stringify(headerState));

            var isTransferPartial = false;

            detailState.flatMap(element => {
                submitTransfernoDetailState[indexKey] = [element['LINENO'], element['PRDID'], element['LINE'], element['PARTNO'], element['ORDERQTY'], element['TRANSFERQTY'], element['USER_INPUT_QTY']]
                // console.log('PostActions fetchSubmitPartialTransfernoDetail element[TRANSFERQTY]: ' + element['TRANSFERQTY'])
                // console.log('PostActions fetchSubmitPartialTransfernoDetail element[USER_INPUT_QTY]: ' + element['USER_INPUT_QTY'])

                if(element['TRANSFERQTY'] !== element['USER_INPUT_QTY']){
                    isTransferPartial = true
                }
                indexKey=indexKey+1;
            })            
            submitTransfernoDetailState['userid'] = user['userid']
            submitTransfernoDetailState['TRANSFERNO'] = headerState['TRANSFERNO']
            submitTransfernoDetailState['FROMLOC'] = headerState['FROMLOC']
            submitTransfernoDetailState['TOLOC'] = headerState['TOLOC']
            submitTransfernoDetailState['MODE'] = headerState['MODE']
           

            // console.log('fetchSubmitPartialTransfernoDetail submitTransfernoDetailState: ' + JSON.stringify(submitTransfernoDetailState));

            let transferCall = 'submitPartialTransfernoDetail'

            if(isTransferPartial === false){
                transferCall = 'submitTransfernoDetail'
            }
            // console.log('PostActions fetchSubmitPartialTransfernoDetail isTransferPartial ' + isTransferPartial)
            const res = await Axios.post(`${BASEURL2}/${transferCall}`, qs.stringify(submitTransfernoDetailState, { indices: false }), { HEADERS });
            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined'&& typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){ 
                // console.log('PostActions fetchSubmitPartialTransfernoDetail data message: ' + JSON.stringify(data['message']));

                dispatch({
                    type: SUBMIT_TRANSFER_RESPONSE,
                    payload: data['message']
                })
                unhideLandingPageClasses()        
            }
            else{    
                console.log('PostActions fetchSubmitPartialTransfernoDetail data[ERROR]: ' + JSON.stringify(data['ERROR']));     

                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: data['ERROR']
                }) 
            }                      
        } catch (error){
            console.log('PostActions fetchSubmitPartialTransfernoDetail failed error: ' + error)
            dispatch({                    
                type: STATUS_ERR_MESSAGE,   
                payload: error
            })           
        }  
    }
};


export const fetchOrders = (user) => dispatch => {    
    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name}

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchOrders`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchOrders data: ' + JSON.stringify(data)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined'){
                
                const formattedData = data.message.map(row => {
                    const updatedRow = {
                        ...row,
                        ORDERED: row.ORDERED !== null && row.ORDERED !== '' ? moment(row.ORDERED, 'MM/DD/YYYY').toDate() : '',
                    };

                    return updatedRow;
                });

                dispatch({
                    type: FETCH_ORDERS,
                    payload: formattedData, 
                });                                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: FETCH_ORDERS,
                    payload: data['NOTIFY'],
                });                
                                
            }            
            else{

                var failedResponse = 'Fetch Orders Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 

                // dispatch({
                //     type: AuthActionType.LOGIN_FAIL,
                //     payload: failedResponse
                // });

                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchOrders fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchOrders error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchOrdernoDetail = (user, orderno) => dispatch => {    
    try{
        //VALIDATE input was entered
        // const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name, 'ORDERNO': orderno}
        const param = {'USERID': user.userid, 'ORDERNO': orderno}

        dispatch({
            type: STATUS_UPDATE_STATE_RESET
        });  

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchOrdernoDetail`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){                
                dispatch({
                    type: TRANSFERNO_STATE_RESET
                });         
                dispatch({
                    type: CUSTOMER_TRANSFER_STATE_RESET
                });    
                dispatch({
                    type: FETCH_INVENTORY_RESET
                });                  
                dispatch({
                    type: FETCH_ORDERNO_DETAIL,
                    payload: data.message,
                });
                
                hideLandingPageClasses() 
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchOrdernoDetail data notify:' + JSON.stringify(data['NOTIFY'])); 
                
                //dispatch(fetchOrders(user));

                dispatch({
                    type: STATUS_NOTICE_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }             
            else{

                var failedResponse = 'Fetch Orders Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 

                // dispatch({
                //     type: AuthActionType.LOGIN_FAIL,
                //     payload: failedResponse
                // });

                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchOrdernoDetail fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchOrdernoDetail error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const addLineOrdernoDetail = () => {

    return async (dispatch) => {
        try{

            dispatch({
                type: ADD_LINE_ORDERNO_DETAIL,                
            })                                                   
        } catch (error){
            console.log('PostActions addLineOrdernoDetail failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const deleteRowLineOrdernoDetail = (dataIndex) => {
    return async (dispatch) => {
        try{

            dispatch({
                type: DELETE_ROW_LINE_ORDERNO_DETAIL,
                payload: dataIndex
                
            })                                                   
        } catch (error){
            console.log('PostActions deleteRowLineOrdernoDetail failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const fetchSubmitOrdernoDetail = (orderDetailState, corePickupState) => {
    return async (dispatch) => {
        try{

            let submitState = {}
            let indexKey = 0

            for (const [key, value] of Object.entries(corePickupState)) {
                // console.log(key, value);
                submitState[key] = value;
            }

            orderDetailState.flatMap(element => {
                submitState[indexKey] = [element['ORDERNO'], element['USERID'], element['LINENO'], element['PRDID'], element['LINE'], element['PARTNO'], element['ORDERQTY'], element['SHIPPEDQTY'], element['ORDER_CUSTID'], element['USER_INPUT_QTY'], element['QTY_TYPE']]
                indexKey=indexKey+1;
            })            
            
            const res = await Axios.post(`${BASEURL2}/submitOrdernoDetail`, qs.stringify(submitState, { indices: false }), { HEADERS });
            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined'&& typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){ 
                // console.log('PostActions fetchSubmitOrdernoDetail data message: ' + JSON.stringify(data['message']));

                dispatch({
                    type: SUBMIT_ORDER_RESPONSE,
                    payload: data['message']
                })  
                
                unhideLandingPageClasses() 
            }
            else{    
                console.log('PostActions fetchSubmitOrdernoDetail data[ERROR]: ' + JSON.stringify(data['ERROR']));     

                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: data['ERROR']
                }) 
            }                      
        } catch (error){
            console.log('PostActions fetchSubmitOrdernoDetail failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const PrintOrder = () => {
    // console.log('PostActions PrintIcon called');

    return async (dispatch) => {
        try{

            dispatch({
                type: PRINT_ORDER            
            })                                                   
        } catch (error){
            console.log('PostActions PrintIcon failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const fetchOrdernosPrintPicktickets = (user, ordernos) => dispatch => {    
    try{
        // console.log('PostActions fetchOrdernosPrintPicktickets called'); 

        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ORDERNO': ordernos}

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchOrdernosPrintPicktickets`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchOrdernosPrintPicktickets data: ' + JSON.stringify(data)); 
            // console.log('PostActions fetchOrdernosPrintPicktickets data.message: ' + JSON.stringify(data.message)); 

            for(var i in data){
                // console.log('PostActions fetchOrdernosPrintPicktickets data i: ' + JSON.stringify(data[i])); 

            }
            if(typeof(data[0]['ERROR']) === 'undefined' && typeof(data[0]['message']) !== 'undefined'){        
                dispatch({
                    type: FETCH_ORDERNOS_PRINT,
                    // payload: data['message'],
                    payload: data, 

                });                              
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: FETCH_ORDERNOS_PRINT,
                    payload: data['NOTIFY'],
                });                                                
            }            
            else{

                var failedResponse = 'Fetch InvoicesPrintDetail Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchOrdernosPrintPicktickets fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchOrdernosPrintPicktickets error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const PrintTransfer = () => {
    // console.log('PostActions PrintIcon called');

    return async (dispatch) => {
        try{

            dispatch({
                type: PRINT_TRANSFER             
            })                                                   
        } catch (error){
            console.log('PostActions PrintIcon failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const fetchCustomers = (user) => dispatch => {
    
    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name}  

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchCustomers`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' ){
                
                const formattedData = data.message.map(row => {
                    const updatedRow = {
                        ...row,
                        LASTSALE: row.LASTSALE !== null && row.LASTSALE !== '' ? moment(row.LASTSALE, 'MM/DD/YYYY').toDate() : '',
                        LASTCOREINVOICED: row.LASTCOREINVOICED !== null && row.LASTCOREINVOICED !== '' ? moment(row.LASTCOREINVOICED, 'MM/DD/YYYY').toDate() : '',
                        LASTBATTERYSALEINVOICED: row.LASTBATTERYSALEINVOICED !== null && row.LASTBATTERYSALEINVOICED !== '' ? moment(row.LASTBATTERYSALEINVOICED, 'MM/DD/YYYY').toDate() : '',

                    };

                    return updatedRow;
                });

                dispatch({
                    type: FETCH_CUSTOMERS,
                    payload: formattedData,
                });                
                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchCustomers data notify:' + JSON.stringify(data['NOTIFY'])); 
                dispatch({
                    type: FETCH_CUSTOMERS,
                    payload: data['NOTIFY'],
                });                
                                
            }               
            else{

                var failedResponse = 'Fetch Customer Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 

                // dispatch({
                //     type: AuthActionType.LOGIN_FAIL,
                //     payload: failedResponse
                // });

                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchCustomers fail: ' + failedResponse);
            }
        })
    } catch (error) {
        console.log('PostActions fetchCustomers error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchCustnoDetail = (user, custid, searchCustno='') => dispatch => {
    
    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name, 'CUSTID': custid, 'SEARCHCUSTNO': searchCustno}

        dispatch({
            type: STATUS_UPDATE_STATE_RESET
        });  

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchCustnoDetail`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchCustnoDetail data: ' + JSON.stringify(data)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                dispatch({
                    type: TRANSFERNO_STATE_RESET
                });         

                dispatch({
                    type: ORDER_TRANSFER_STATE_RESET
                });  

                dispatch({
                    type: FETCH_INVENTORY_RESET
                });  
                dispatch({
                    type: ROTATE_REQUEST,
                    payload: [0],
                });  
                dispatch({
                    type: RETURNS,
                    payload: [0],
                });                                   
                dispatch({
                    type: FETCH_CUSTNO_DETAIL,
                    payload: data.message,
                });   
                dispatch({
                    type: NO_ROTATES_NEEDED_CB,
                    payload: false,
                });                 
                dispatch({
                    type: NO_RETURNS_NEEDED_CB,
                    payload: false,
                });                  
                hideLandingPageClasses()                 
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchCustnoDetail data notify:' + JSON.stringify(data['NOTIFY'])); 
                dispatch({
                    type: STATUS_NOTICE_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }              
            else{

                var failedResponse = 'Fetch Cust Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchCustnoDetail fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchCustnoDetail error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchSubmitCustnoDetail = (custnoDetailState, corePickupState, userid, returnsCommentState) => {
    return async (dispatch, getState) => {
        try{
            let errorFound = false;            
            let rotateRequestState = getState().rotatesReducer['items_rotateRequestState']
            let noRotatesNeededCbState = getState().rotatesReducer['noRotatesNeededCbState']

            let returnsState = getState().returnsReducer['items_returnsState']
            let noReturnsNeededCbState = getState().returnsReducer['noReturnsNeededCbState']

            if(noRotatesNeededCbState === true){
                rotateRequestState = null
            }
            
            //validate input
            for (let i in rotateRequestState){
                if(rotateRequestState[i]['PARTNO'] === '' && (rotateRequestState[i]['VOLTAGE'] !== '' || rotateRequestState[i]['DATECODE'] !== '')){
                    console.log('PostActions fetchSubmitCustnoDetail Partno needed for rotate request line: ' + rotateRequestState[i])
                    errorFound = true;

                    alert('Partno needed for rotate request')
                    // dispatch({                    
                    //     type: STATUS_ERR_MESSAGE,   
                    //     payload: 'Partno needed for rotate request'
                    // }) 

                    break
                }
            }

            if(noReturnsNeededCbState === true){
                returnsState = null
            }
            
            //validate input
            for (let i in returnsState){
                if(returnsState[i]['PARTNO'] === '' && (returnsState[i]['QTY'] !== '')){
                    console.log('PostActions fetchSubmitCustnoDetail Partno needed for returns line: ' + rotateRequestState[i])
                    errorFound = true;

                    alert('Partno needed for new returns');
                    break;
                }

                if(returnsState[i]['PARTNO'] !== '' && (returnsState[i]['QTY'] === '0' || returnsState[i]['QTY'] === '')){
                    console.log('PostActions fetchSubmitCustnoDetail QTY needed for returns line: ' + rotateRequestState[i])
                    errorFound = true;

                    alert('New Return QTY not entered. Please enter QTY or remove line for partno: ' + returnsState[i]['PARTNO']);
                    break;
                }    
      
            }

            if(errorFound !== true){
                let submitState = {}
                submitState['CUSTNO'] = custnoDetailState['CUSTNO']
                submitState['ROTATEREQUEST'] = rotateRequestState 
                submitState['NOROTATESNEEDED'] = noRotatesNeededCbState
                submitState['RETURNS'] = returnsState 
                submitState['NORETURNSNEEDED'] = noReturnsNeededCbState                
                submitState['USERID'] = userid
                submitState['CUSTIDROTATES'] = custnoDetailState['CUSTID']

                for (const [key, value] of Object.entries(corePickupState)) {
                    // console.log(key, value);
                    submitState[key] = value;
                }
                  
                for (const [key, value] of Object.entries(returnsCommentState)) {
                    //console.log(key, value);
                    submitState[key] = value;
                }                
                
                const res = await Axios.post(`${BASEURL2}/submitCustnoDetail`, qs.stringify(submitState, { indices: false }), { HEADERS });
                const { data } = res;
                console.log('postAction submitCustnoDetail data', data);

                dispatch({
                    type: STATUS_UPDATE_STATE_RESET
                });

                if(typeof(data['ERROR']) === 'undefined'&& typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){ 
                    console.log('postAction submitCustnoDetail failed length', Object.keys(data['message']['FAILED_UPDATES']).length);

                    if(Object.keys(data['message']['FAILED_UPDATES']).length > 0){  

                        dispatch({                    
                            type: STATUS_ERR_MESSAGE,   
                            payload: data['message']['FAILED_UPDATES']
                        }) 
                    }
                    else{
                        console.log('postAction submitCustnoDetail data message', data['message']);

                        dispatch({
                            type: SUBMIT_CUST_CORE_RESPONSE,
                            payload: data['message']
                        })  
                        unhideLandingPageClasses()   
                    }                    
                }
                else{    
                    console.log('PostActions fetchSubmitCustnoDetail data[ERROR]: ' + JSON.stringify(data['ERROR']));     
    
                    dispatch({                    
                        type: STATUS_ERR_MESSAGE,   
                        payload: data['ERROR']
                    }) 
                }   
            }
                   
        } catch (error){
            console.log('PostActions fetchSubmitCustnoDetail failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const fetchCustomerDetailReset = () => dispatch => {    
    try{
        // console.log('PostActions fetchCustomerDetailReset called'); 

        dispatch({
            type: CUSTOMER_TRANSFER_STATE_RESET,
        });
    } catch (error) {
        console.log('PostActions fetchCustomerDetailReset error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const setCorePickupState = (rows) => dispatch => {
    try {
        // console.log('postAction setCorePickupState rows', rows)
        dispatch({                    
            type: CORE_PICKUP,   
            payload: rows
        })   
    } catch (error) {
        console.log('PostActions setCorePickupState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const fetchInventory = (user) => dispatch => {
    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name}

        Axios.post(`${BASEURL2}/fetchInventory`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                dispatch({
                    type: FETCH_INVENTORY,
                    payload: data.message,
                });                
                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchInventory data notify:' + JSON.stringify(data['NOTIFY'])); 
                dispatch({
                    type: FETCH_INVENTORY,
                    payload: data['NOTIFY'],
                });                
                                
            }                 
            else{

                var failedResponse = 'Fetch Inventory Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchInventory fail: ' + failedResponse);
            }
        })    
    } catch (error) {
        console.log('PostActions fetchInventory error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchInventoryDetail = (user, rowData) => dispatch => {    
    try{
        //VALIDATE input was entered
        let loc = rowData[0]

        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name, 'LOC': loc}
        window.scrollTo(0, 0);
        
        dispatch({
            type: STATUS_UPDATE_STATE_RESET
        });  

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchInventoryDetail`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchInventoryDetail data: ' + JSON.stringify( data)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                dispatch({
                    type: TRANSFERNO_STATE_RESET
                });         

                dispatch({
                    type: ORDER_TRANSFER_STATE_RESET
                });  
                dispatch({
                    type: CUSTOMER_TRANSFER_STATE_RESET
                });   
                dispatch({
                    type: FETCH_INVENTORY_DETAIL,
                    payload: data.message,
                    locheader: rowData,
                });  

                hideLandingPageClasses()                 
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchInventoryDetail data notify:' + JSON.stringify(data['NOTIFY'])); 
                dispatch({
                    type: STATUS_NOTICE_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }              
            else{

                var failedResponse = 'Fetch Inventory Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchInventoryDetail fail: ' + failedResponse);
            }
        });


    } catch (error) {
        console.log('PostActions fetchInventoryDetail error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchInventoryDetailPartnos = (user, loc) => dispatch => {    
    try{
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name, 'LOC': loc}

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchInventoryDetailMorePartnos`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchInventoryDetailPartnos data: ' + JSON.stringify( data)); 

            // dispatch({
            //     type: STATUS_UPDATE_STATE_RESET
            // });  
            
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' ){   
                
                let excludeLine = ['BCR','EBT','MID','MIS','QCC']

                dispatch({
                    type: ROTATE_REQUEST_PARTNO_LIST,
                    payload: data.message.filter(item => !excludeLine.includes(item['LINE']) ).map( (item) => { 
                        let dic = {}
                        dic['value'] = item['LINE'] + item['PARTNO'] 
                        dic['label'] = item['LINE'] + item['PARTNO']
                        return dic;
                    }, {} )                   
                });  

                dispatch({
                    type: RETURNS_PARTNO_LIST,
                    payload: data.message.filter(item => !excludeLine.includes(item['LINE']) ).map( (item) => { 
                        let dic = {}
                        dic['value'] = item['LINE'] + item['PARTNO'] 
                        dic['label'] = item['LINE'] + item['PARTNO']
                        return dic;
                    }, {} )                   
                });                  
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                console.log('PostActions fetchInventoryDetailPartnos data notify:' + JSON.stringify(data['NOTIFY'])); 
                dispatch({
                    type: STATUS_NOTICE_MESSAGE,
                    payload: data['NOTIFY'],
                });                
            }              
            else{

                var failedResponse = 'Fetch Inventory Partnos Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchInventoryDetailPartnos fail: ' + failedResponse);
            }
        });


    } catch (error) {
        console.log('PostActions fetchInventoryDetailPartnos error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchInvoices = (user) => dispatch => {    

    try{
        //VALIDATE input was entered
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name}

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchInvoices`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchInvoices data: ' + JSON.stringify(data)); 
            // console.log('PostActions fetchInvoices data.message: ' + JSON.stringify(data.message)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined'){        
                dispatch({
                    type: FETCH_INVOICES,
                    payload: data.message, 
                });  
                
                dispatch({
                    type: FETCH_RESET_INVOICES_PRINT,
                });                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: FETCH_INVOICES,
                    payload: data['NOTIFY'],
                });                
                                
            }            
            else{

                var failedResponse = 'Fetch Invoices Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchInvoices fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchInvoices error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchInvoicesPrintDetail = (invoices) => dispatch => {    
    try{
        // console.log('PostActions fetchInvoicesPrintDetail called'); 

        //VALIDATE input was entered
        const param = {'INVOICES': invoices}

        // //todo check loginState from server; ex:
        Axios.post(`${BASEURL2}/fetchInvoicesPrintDetail`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchInvoicesPrintDetail data: ' + JSON.stringify(data)); 
            // console.log('PostActions fetchInvoicesPrintDetail data.message: ' + JSON.stringify(data.message)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined'){        
                dispatch({
                    type: FETCH_INVOICES_PRINT,
                    payload: data['message'], 
                });                              
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: FETCH_INVOICES_PRINT,
                    payload: data['NOTIFY'],
                });                
                                
            }            
            else{

                var failedResponse = 'Fetch InvoicesPrintDetail Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchInvoicesPrintDetail fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchInvoicesPrintDetail error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchInvoicesPrintDetailReset = () => dispatch => {    
    try{
        // console.log('PostActions fetchInvoicesPrintDetailReset called'); 

        dispatch({
            type: FETCH_RESET_INVOICES_PRINT,
        });
    } catch (error) {
        console.log('PostActions fetchInvoicesPrintDetailReset error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }
};

export const fetchInvoicesPrintRecordPrinted = (user, invoices) => dispatch => {    
    try{
        console.log('PostActions fetchInvoicesPrintRecordPrinted called invoices: ', invoices); 

        //VALIDATE input was entered
        const param = {'INVOICES': invoices}
        
        Axios.post(`${BASEURL2}/updateInvoicesPrintRecordPrinted`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchInvoicesPrintRecordPrinted data: ' + JSON.stringify(data)); 
            // console.log('PostActions fetchInvoicesPrintRecordPrinted data.message: ' + JSON.stringify(data.message)); 

            //TODO: GIVE UPDATE SUCCESSFUL_UPDATES or FAILED_UPDATES STATUS --- statusupdate.js
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined'){        
                dispatch({
                    type: FETCH_INVOICES_PRINT_RECORD_PRINTED,
                    payload: data['message'],
                });  
                
                // fetchInvoices(user)
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: STATUS_ERR_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }            
            else{

                var failedResponse = 'Fetch fetchInvoicesPrintRecordPrinted Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchInvoicesPrintRecordPrinted fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchInvoicesPrintRecordPrinted error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }            
};

export const setRowsDataSelectedIndexState = (rowsSelected) => dispatch => {
    try {
        dispatch({                    
            type: ROWS_DATA_SELECTED_INDEX_STATE,   
            payload: rowsSelected
        })   
    } catch (error) {
        console.log('PostActions setRowsDataSelectedIndexState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const setRotateRequestState = (rows) => dispatch => {
    try {
        dispatch({                    
            type: ROTATE_REQUEST,   
            payload: rows
        })   

        dispatch({                    
            type: ROTATES,   
            payload: []
        })  
        
        dispatch({                    
            type: ROTATES_OUT_OF_STOCK,   
            payload: []
        })         
    } catch (error) {
        console.log('PostActions setRotateRequestState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const setRotatesState = (rows) => dispatch => {
    try {
        dispatch({                    
            type: ROTATES,   
            payload: rows
        })  
        
        dispatch({                    
            type: ROTATE_REQUEST,   
            payload: []
        })           
    } catch (error) {
        console.log('PostActions setRotatesState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const setRotatesOutOfStockBatteryState = (rows) => dispatch => {
    try {
        dispatch({                    
            type: ROTATES_OUT_OF_STOCK,   
            payload: rows
        })  
        
        dispatch({                    
            type: ROTATE_REQUEST,   
            payload: []
        })           
    } catch (error) {
        console.log('PostActions setRotatesOutOfStockBatteryState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const fetchRotatesInvno = (invno) => dispatch => {

    try{
        // console.log('PostActions fetchRotatesInvno called invno: ', invno); 

        //VALIDATE input was entered
        const param = {'INVNO': invno}
        
        Axios.post(`${BASEURL2}/fetchRotatesInvno`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('PostActions fetchRotatesInvno data: ' + JSON.stringify(data)); 
            // console.log('PostActions fetchRotatesInvno data.message: ' + JSON.stringify(data.message)); 

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined'){        
                
                dispatch({
                    type: ROTATE_REQUEST,
                    payload: [],
                });  

                dispatch({
                    type: ROTATES,
                    payload: data['message']['ROTATE'],
                });  
                
                dispatch({
                    type: ROTATES_OUT_OF_STOCK,
                    payload: data['message']['ROTATE_OUT_OF_STOCK'],
                });                  
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: STATUS_ERR_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }            
            else{

                var failedResponse = 'Fetch fetchRotatesInvno Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchRotatesInvno fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions fetchRotatesInvno error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    } 
    
}

export const fetchSubmitInvnoConfirmation = (user, clickedInvnoState, corePickupState,custid, returnsCommentState, invnoDeliveryDateState) => {
    console.log('user',user, 'clickedInvnoState', clickedInvnoState, 'corePickupState', corePickupState,custid, returnsCommentState, invnoDeliveryDateState)
    return async (dispatch, getState) => {
        try{
            let errorFound = false;

            let rotateRequestState = getState().rotatesReducer['items_rotateRequestState']
            let rotatesState = getState().rotatesReducer['items_rotatesState']
            let rotatesOutOfStockBatteryState = getState().rotatesReducer['items_rotateInvoiceOutOfStockBatteryState']
            let noRotatesNeededCbState = getState().rotatesReducer['noRotatesNeededCbState']

            let returnsState = getState().returnsReducer['items_returnsState']
            let noReturnsNeededCbState = getState().returnsReducer['noReturnsNeededCbState']

            if(noRotatesNeededCbState === true){
                rotateRequestState = null
            }

            //validate input
            for (let i in rotateRequestState){
                if(rotateRequestState[i]['PARTNO'] === '' && (rotateRequestState[i]['VOLTAGE'] !== '' || rotateRequestState[i]['DATECODE'] !== '')){
                    console.log('PostActions fetchSubmitInvnoConfirmation Partno needed for rotate request line: ' + rotateRequestState[i])
                    errorFound = true;

                    alert('Partno needed for rotate request')
                    break
                }
            }

            if(noReturnsNeededCbState === true){
                returnsState = null
            }
            
            //validate input
            for (let i in returnsState){
                if(returnsState[i]['PARTNO'] === '' && (returnsState[i]['QTY'] !== '')){
                    console.log('PostActions fetchSubmitInvnoConfirmation Partno needed for returns line: ' + rotateRequestState[i])
                    errorFound = true;

                    alert('Partno needed for returns');
                    break;
                }
            }

            //validate input
            for (let i in rotatesState){
                if(rotatesState[i]['ROTATE_CODE'] === ''){
                    console.log('PostActions fetchSubmitInvnoConfirmation rotate code needed for partno: ' + rotatesState[i]['PARTNO'])
                    errorFound = true;

                    alert('Please select a Rotate Result for partno: ' + rotatesState[i]['PARTNO'])
                    break
                }
            }

            //validate input
            for (let i in rotatesOutOfStockBatteryState){
                if(rotatesOutOfStockBatteryState[i]['ROTATE_CODE'] === ''){
                    console.log('PostActions fetchSubmitInvnoConfirmation rotatesOutOfStockBatteryState code needed for partno: ' + rotatesOutOfStockBatteryState[i]['PARTNO'])
                    errorFound = true;

                    alert('Please select a Rotate Result for partno: ' + rotatesOutOfStockBatteryState[i]['PARTNO'])
                    break
                }
            }

            if(errorFound !== true){
                let submitState = {}
                let indexKey = 0
    
                for (const [key, value] of Object.entries(corePickupState)) {
                    // console.log(key, value);
                    submitState[key] = value;
                }
                
                for (const [key, value] of Object.entries(returnsCommentState)) {
                    //console.log(key, value);
                    submitState[key] = value;
                }                   
                
                submitState['ROTATEREQUEST'] = rotateRequestState 
                submitState['ROTATES'] = rotatesState 
                submitState['ROTATESOUTOFSTOCK'] = rotatesOutOfStockBatteryState
                submitState['NOROTATESNEEDED'] = noRotatesNeededCbState
                submitState['RETURNS'] = returnsState 
                submitState['NORETURNSNEEDED'] = noReturnsNeededCbState                
                submitState['USERID'] = user.userid
                submitState['CUSTID'] = custid

                submitState['DELIVERY_DATE'] = invnoDeliveryDateState
                
                submitState[0] = [clickedInvnoState]
    
                // clickedInvnoState.flatMap(element => {
                //     submitState[indexKey] = [element['INVNO']]
                //     indexKey=indexKey+1;
                // })            
                console.log('PostActions fetchSubmitInvnoConfirmation submitState: ', submitState);
    
                const res = await Axios.post(`${BASEURL2}/submitInvnoConfirmation`, qs.stringify(submitState, { indices: false }), { HEADERS });
    
                const { data } = res;
                console.log('PostActions fetchSubmitInvnoConfirmation data ', data)
    
                if(typeof(data['ERROR']) === 'undefined'&& typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){ 
                    if(data['message']['FAILED_UPDATES'].length > 0){
                        console.log('PostActions fetchSubmitInvnoConfirmation error message: ', data['message']['FAILED_UPDATES'])

                        alert('Submit unsuccessful. ERROR: ' + data['message']['FAILED_UPDATES'])

                        dispatch({
                            type: STATUS_ERR_MESSAGE,
                            payload: data['message']['FAILED_UPDATES']
                        })  
                    }
                    else if(data['message']['NOTICE_UPDATES'].length > 0){                    
                        dispatch({
                            type: ROWS_DATA_SELECTED_INDEX_STATE,
                            payload: []     //reset
                        }) 
    
                        dispatch({
                            type: STATUS_NOTICE_MESSAGE,
                            payload: data['message']['NOTICE_UPDATES']
                        })  
    
                        dispatch({
                            type: CUSTOMER_TRANSFER_STATE_RESET
                        })                      
                        
                        dispatch(fetchInvoices(user)) //refresh tbl                    
                    }                
                    else if(data['message']['SUCCESSFUL_UPDATES'].length > 0){
                                            
                        dispatch({
                            type: ROWS_DATA_SELECTED_INDEX_STATE,
                            payload: []     //reset
                        }) 
    
                        dispatch({
                            type: PRINT_CONFIRMATION_RESPONSE,
                            payload: data['message']['SUCCESSFUL_UPDATES']
                        })  
    
                        dispatch({
                            type: CUSTOMER_TRANSFER_STATE_RESET
                        })                      
                        
                        dispatch(fetchInvoices(user)) //refresh tbl
                    }
                    
                    // unhideLandingPageClasses() 
                }
                else{    
                    console.log('PostActions fetchSubmitInvnoConfirmation data[ERROR]: ' + JSON.stringify(data['ERROR']));     
    
                    alert('Submit failed - ERROR: ' + JSON.stringify(data['ERROR']))
                    dispatch({                    
                        type: STATUS_ERR_MESSAGE,   
                        payload: data['ERROR']
                    }) 
                }   
            }
                               
        } catch (error){
            console.log('PostActions fetchSubmitInvnoConfirmation failed error: ' + error)
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}

export const clearInvnoConfirmationStatus = () => dispatch => {
    try {
        dispatch({                    
            type: PRINT_CONFIRMATION_CLEAR_MESSAGES
        })   
    } catch (error) {
        console.log('PostActions clearInvnoConfirmationStatus error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

// export const fetchValidateRotatesPartno = (partno) => dispatch => {
//     try{
//         if(partno === '' || partno === false){
//             dispatch({
//                 type: VALID_ROTATES_PARTNO,
//                 payload: false
//             });   
//         }
//         else{
//             //VALIDATE input was entered
//             const param = {'PARTNO': partno}

//             Axios.post(`${BASEURL2}/fetchValidateRotatesPartno`, qs.stringify(param, {indices: false}), { HEADERS })
//             .then( function(res){
//                 const { data } = res;

//                 if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
//                     if(data['message'] === 'true'){
//                         dispatch({
//                             type: VALID_ROTATES_PARTNO,
//                             payload: true
//                         });     
//                     }
//                     else{
//                         dispatch({
//                             type: VALID_ROTATES_PARTNO,
//                             payload: false
//                         });     
//                     }
//                 }
//                 else{

//                     var failedResponse = 'Fetch ValidateRotatesPartno Failed'
//                     if(typeof(data['ERROR']) !== 'undefined'){
//                         failedResponse = data['ERROR']
//                     } 

//                     dispatch({                    
//                         type: STATUS_ERR_MESSAGE,   
//                         payload: failedResponse
//                     })    

//                     console.log('PostActions fetchValidateRotatesPartno fail: ' + failedResponse);
//                 }
//             });
//         }

//     } catch (error) {
//         console.log('PostActions fetchValidateRotatesPartno error: ' + error);
//         if(error){
//             // dispatch({
//             //     type: AuthActionType.LOGIN_FAIL,
//             //     payload: error.toString() //error.response.data.message
//             // });
//         }
            
//         dispatch({                    
//             type: STATUS_ERR_MESSAGE,   
//             payload: error.toString() //error.response.data.message
//         })    
    
//     }   
// }

export const updateInventoryDetailBin = (loc, prdid, binValue) => dispatch => {    
    try{
        // console.log('PostActions updateInventoryDetailBin called invoices: ', invoices); 

        //VALIDATE input was entered
        const param = {'LOC': loc, 'PRDID': prdid, 'BINVALUE': binValue}
        
        Axios.post(`${BASEURL2}/updateInventoryDetailBin`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            console.log('PostActions updateInventoryDetailBin data: ' + JSON.stringify(data)); 

            //TODO: GIVE UPDATE SUCCESSFUL_UPDATES or FAILED_UPDATES STATUS --- statusupdate.js
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined'){        
                // dispatch({
                //     type: UPDATE_INVENTORY_DETAIL_BIN,
                //     payload: data['message'],
                // });  
                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                dispatch({
                    type: STATUS_ERR_MESSAGE,
                    payload: data['NOTIFY'],
                });                
                                
            }            
            else{

                var failedResponse = 'Fetch updateInventoryDetailBin Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions updateInventoryDetailBin fail: ' + failedResponse);
            }
        });
    } catch (error) {
        console.log('PostActions updateInventoryDetailBin error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
    
    }            
};

export const setNoRotatesNeededCbState = (result) => dispatch => {
    try {
        dispatch({                    
            type: NO_ROTATES_NEEDED_CB,   
            payload: result
        })   

        if(result === true){
            dispatch({                    
                type: ROTATE_REQUEST,
                payload: [0],
            })   
        }
    } catch (error) {
        console.log('PostActions setNoRotatesNeededCbState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const setNoReturnsNeededCbState = (result) => dispatch => {
    try {
        dispatch({                    
            type: NO_RETURNS_NEEDED_CB,   
            payload: result
        })   

        if(result === true){
            dispatch({                    
                type: RETURNS,
                payload: [0],
            })   
        }
    } catch (error) {
        console.log('PostActions setNoReturnsNeededCbState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const setReturnsState = (rows) => dispatch => {
    try {
        dispatch({                    
            type: RETURNS,   
            payload: rows
        })   
        
    } catch (error) {
        console.log('PostActions setReturnsState error: ' + error);
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString()
        }) 
    }
}

export const fetchValidatePartno = (partno) => async dispatch => {    
    try{
        //VALIDATE input was entered
        const param = {'PARTNO': partno}

        // //todo check loginState from server; ex:
        await Axios.post(`${BASEURL2}/fetchValidatePartno`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;

            console.log('fetchValidatePartno data', data)

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && data['message'] === true ){
                dispatch({
                    type: VALIDATE_PARTNO,
                    payload: partno //data.message
                });      
                
               // console.log('fetchValidatePartno return', {value: partno, label: partno, isValid: true} )

                //return { value: partno, label: partno, isValid: true };
            }
            else{

                var failedResponse = 'Fetch ValidatePartno Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                } 
                else if(typeof(data['message']) !== 'undefined' && data['message'] === false){
                    failedResponse = 'Partno ' + partno + ' is not valid'
                }

                
                dispatch({                    
                    type: STATUS_ERR_MESSAGE,   
                    payload: failedResponse
                })    

                console.log('PostActions fetchValidatePartno fail: ' + failedResponse);

                //return { value: partno, label: partno, isValid: false, message: data.ERROR || 'Invalid Part Number' };
            }
        });
    } catch (error) {
        console.log('PostActions fetchValidatePartno error: ' + error);
        if(error){
            // dispatch({
            //     type: AuthActionType.LOGIN_FAIL,
            //     payload: error.toString() //error.response.data.message
            // });
        }
            
        dispatch({                    
            type: STATUS_ERR_MESSAGE,   
            payload: error.toString() //error.response.data.message
        })    
        

        return { value: partno, label: partno, isValid: false, message: error.toString() };
    }
};
